module.exports = "#BG{\r\n    margin: 10px;\r\n}\r\n\r\n\r\n\r\n\r\n"